import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const CopyLink = ({ path, testid = "copy-link" }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.origin + path;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="flex items-center gap-2 rounded-xl border border-gray-200 bg-oath-bg/70 p-1.5 pl-3" data-testid={testid}>
      <code className="min-w-0 flex-1 truncate font-mono text-[11px] text-oath-ink" data-testid={`${testid}-url`}>{url}</code>
      <button type="button" onClick={copy} data-testid={`${testid}-button`}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-oath-ink px-3 py-1.5 text-xs font-medium text-white hover:bg-black">
        {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
};

export default CopyLink;
